import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=4b40ecf3&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=4b40ecf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40ecf3",
  null
  
)

export default component.exports